// // import { useState, useRef, useEffect, useCallback } from "react";
// // import "./css/EventSliders.css";
// // const posts = [
// //   {
// //     id: 1,
// //     date: "May 2, 2018",
// //     author: "Letizia Biafore",
// //     category: "Yoga",
// //     title: "Best Ways To Sneak Yoga Into Your Holiday",
// //     tags: ["LIFESTYLE", "YOGA", "TRAVEL"],
// //     image: "https://images.pexels.com/photos/6138896/pexels-photo-6138896.jpeg",
// //     gallery: [
// //       "https://images.pexels.com/photos/33243963/pexels-photo-33243963.jpeg",
// //       "https://images.pexels.com/photos/8818591/pexels-photo-8818591.jpeg",
// //       "https://images.pexels.com/photos/5877926/pexels-photo-5877926.jpeg",
// //     ],
// //   },
// //  {
// //     id: 2,
// //     date: "Mar 14, 2025",
// //     author: "Admin",
// //     category: "Holi",
// //     title: "Colors of Joy and Happiness",
// //     tags: ["HOLI", "COLORS", "CELEBRATION"],
// //     image: "https://images.pexels.com/photos/36574176/pexels-photo-36574176.jpeg",
// //     gallery: [
// //       "https://images.pexels.com/photos/15741140/pexels-photo-15741140.jpeg",
// //       "https://images.pexels.com/photos/16125035/pexels-photo-16125035.jpeg"
// //     ],
// //   },

// // ];



// // function useCardsPerView() {
// //   const [cards, setCards] = useState(1);
// //   useEffect(() => {
// //     const update = () => {
// //       const w = window.innerWidth;
// //       if (w >= 1024) setCards(3);
// //       else if (w >= 640) setCards(2);
// //       else setCards(1);
// //     };
// //     update();
// //     window.addEventListener("resize", update);
// //     return () => window.removeEventListener("resize", update);
// //   }, []);
// //   return cards;
// // }

// // // ── Gallery Popup ────────────────────────────────────────────────────────────
// // function GalleryPopup({ post, onClose }) {
// //   const [activeIdx, setActiveIdx] = useState(0);
// //   const [zoom, setZoom] = useState(false);
// //   const total = post.gallery.length;

// //   const prev = () => setActiveIdx((i) => (i - 1 + total) % total);
// //   const next = () => setActiveIdx((i) => (i + 1) % total);

// //   // Close on Escape, nav on arrows
// //   useEffect(() => {
// //     const handler = (e) => {
// //       if (e.key === "Escape") onClose();
// //       if (e.key === "ArrowLeft") prev();
// //       if (e.key === "ArrowRight") next();
// //     };
// //     window.addEventListener("keydown", handler);
// //     return () => window.removeEventListener("keydown", handler);
// //   }, []);

// //   // Prevent body scroll
// //   useEffect(() => {
// //     document.body.style.overflow = "hidden";
// //     return () => { document.body.style.overflow = ""; };
// //   }, []);

// //   const pad = (n) => String(n + 1).padStart(2, "0");

// //   return (
// //     <div className="GP-backdrop" onClick={onClose}>
// //       <div className="GP-modal" onClick={(e) => e.stopPropagation()}>
// //         {/* Header */}
// //         <div className="GP-header">
// //           <div className="GP-header-title">
// //             {/* <span className="GP-header-cat">{post.category}</span> */}
// //             <span className="GP-header-name">{post.title}</span>
// //           </div>
// //           <button className="GP-close" onClick={onClose}>CLOSE</button>
// //         </div>

// //         {/* Main image */}
// //         <div className={`GP-main-wrap ${zoom ? "GP-zoomed" : ""}`} onClick={() => setZoom((z) => !z)}>
// //           <img
// //             className="GP-main-img"
// //             src={post.gallery[activeIdx]}
// //             alt={`Photo ${activeIdx + 1}`}
// //           />
// //           <div className="GP-img-label">PHOTO {pad(activeIdx)}</div>
// //         </div>

// //         {/* Controls row */}
// //         <div className="GP-controls">
// //           <div className="GP-nav-group">
// //             <button className="GP-nav-btn" onClick={prev} aria-label="Previous">
// //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
// //                 <polyline points="15 18 9 12 15 6"/>
// //               </svg>
// //             </button>
// //             <span className="GP-counter">{pad(activeIdx)} / {pad(total - 1)}</span>
// //             <button className="GP-nav-btn" onClick={next} aria-label="Next">
// //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
// //                 <polyline points="9 18 15 12 9 6"/>
// //               </svg>
// //             </button>
// //           </div>
// //           <div className="GP-zoom-group">
// //             <button className="GP-nav-btn" onClick={() => setZoom(true)} aria-label="Zoom in">
// //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
// //                 <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
// //               </svg>
// //             </button>
// //             <button className="GP-nav-btn" onClick={() => setZoom(false)} aria-label="Zoom out">
// //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
// //                 <line x1="5" y1="12" x2="19" y2="12"/>
// //               </svg>
// //             </button>
// //           </div>
// //         </div>

// //         {/* Thumbnails */}
// //         <div className="GP-thumbs">
// //           {post.gallery.map((src, i) => (
// //             <button
// //               key={i}
// //               className={`GP-thumb ${i === activeIdx ? "GP-thumb-active" : ""}`}
// //               onClick={() => setActiveIdx(i)}
// //             >
// //               <img src={src} alt={`thumb ${i + 1}`} />
// //               <span className="GP-thumb-num">{pad(i)}</span>
// //             </button>
// //           ))}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // // ── Main Component ────────────────────────────────────────────────────────────
// // export default function EventSliders() {
// //   const cardsPerView = useCardsPerView();
// //   const maxIndex = posts.length - cardsPerView;
// //   const [current, setCurrent] = useState(0);
// //   const [galleryPost, setGalleryPost] = useState(null);
// //   const trackRef = useRef(null);
// //   const dragStart = useRef(null);
// //   const dragging = useRef(false);

// //   const clamp = (v) => Math.max(0, Math.min(v, maxIndex));
// //   const prev = useCallback(() => setCurrent((c) => clamp(c - 1)), [maxIndex]);
// //   const next = useCallback(() => setCurrent((c) => clamp(c + 1)), [maxIndex]);

// //   const onDragStart = (clientX) => { dragStart.current = clientX; dragging.current = true; };
// //   const onDragEnd = (clientX) => {
// //     if (!dragging.current) return;
// //     dragging.current = false;
// //     const diff = dragStart.current - clientX;
// //     if (Math.abs(diff) > 50) diff > 0 ? next() : prev();
// //   };

// //   useEffect(() => {
// //     const handler = (e) => {
// //       if (galleryPost) return; // let popup handle arrows
// //       if (e.key === "ArrowLeft") prev();
// //       if (e.key === "ArrowRight") next();
// //     };
// //     window.addEventListener("keydown", handler);
// //     return () => window.removeEventListener("keydown", handler);
// //   }, [prev, next, galleryPost]);

// //   useEffect(() => { setCurrent((c) => clamp(c)); }, [cardsPerView]);

// //   const pct = (100 / cardsPerView) * current;

// //   return (
// //     <>
// //       <style>{`



// //         /* ── Blog Root ── */
// //        `}</style>

// //      <div className="customcontainer">
// //       <div className="EventSliders-blog-root">
// //         <div className="EventSliders-blog-header">
// //           <h2>Festival Celebration</h2>
// //           {/* <p>Stories, tips & adventures — fresh every week</p> */}
// //         </div>

// //         <div className="EventSliders-carousel-wrapper">
// //           <button className="EventSliders-arrow EventSliders-arrow-left" onClick={prev} disabled={current === 0} aria-label="Previous">
// //             <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
// //               <polyline points="15 18 9 12 15 6"/>
// //             </svg>
// //           </button>
// //           <button className="EventSliders-arrow EventSliders-arrow-right" onClick={next} disabled={current >= maxIndex} aria-label="Next">
// //             <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
// //               <polyline points="9 18 15 12 9 6"/>
// //             </svg>
// //           </button>

// //           <div
// //             className="EventSliders-track-container"
// //             ref={trackRef}
// //             onMouseDown={(e) => onDragStart(e.clientX)}
// //             onMouseUp={(e) => onDragEnd(e.clientX)}
// //             onMouseLeave={() => { dragging.current = false; }}
// //             onTouchStart={(e) => onDragStart(e.touches[0].clientX)}
// //             onTouchEnd={(e) => onDragEnd(e.changedTouches[0].clientX)}
// //           >
// //             <div
// //               className="EventSliders-track"
// //               style={{ transform: `translateX(-${pct}%)`, "--cpv": cardsPerView }}
// //             >
// //               {posts.map((post) => (
// //                 <div className="EventSliders-card" key={post.id} style={{ "--cpv": cardsPerView }}>
// //                   <div className="EventSliders-card-inner">
// //                     <img className="EventSliders-card-img" src={post.image} alt={post.title} draggable={false} />
// //                     <div className="EventSliders-card-overlay" />


// //                     {/* Bottom body */}
// //                     <div className="EventSliders-card-body">
// //                       <div className="EventSliders-card-title">{post.title}</div>
// //                       <button
// //                         className="EventSliders-gallery-btn"
// //                         onClick={() => setGalleryPost(post)}
// //                       >
// //                         <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
// //                           <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
// //                           <polyline points="21 15 16 10 5 21"/>
// //                         </svg>
// //                         View Gallery
// //                       </button>
// //                     </div>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //      </div>

// //       {/* Gallery Popup */}
// //       {galleryPost && (
// //         <GalleryPopup post={galleryPost} onClose={() => setGalleryPost(null)} />
// //       )}
// //     </>
// //   );
// // }



// import { useState } from "react";

// const PIN_COLORS = [
//   { head: "#e53935", shine: "#ef9a9a" },
//   { head: "#1e88e5", shine: "#90caf9" },
//   { head: "#fdd835", shine: "#fff176" },
//   { head: "#43a047", shine: "#a5d6a7" },
//   { head: "#e91e63", shine: "#f48fb1" },
//   { head: "#00acc1", shine: "#80deea" },
//   { head: "#8e24aa", shine: "#ce93d8" },
//   { head: "#f4511e", shine: "#ffab91" },
// ];

// const ROTATIONS = [-3, 2, -1.5, 3.5, -2.5, 1.8, -3.8, 2.2, -2.2, 3.1];

// const FRAMES = [
//   { border: "9px solid #fff", bg: "#fff", capColor: "#666" },
// ];

// // const PHOTOS = [
// //   { url: "https://picsum.photos/seed/101/400/300", caption: "Mountain View" },
// //   { url: "https://picsum.photos/seed/202/400/300", caption: "City Lights" },
// //   { url: "https://picsum.photos/seed/303/400/300", caption: "Ocean Waves" },
// //   { url: "https://picsum.photos/seed/404/400/300", caption: "Forest Path" },
// //   { url: "https://picsum.photos/seed/505/400/300", caption: "Sunset Sky" },
// //   { url: "https://picsum.photos/seed/606/400/300", caption: "Golden Hour" },
// //   { url: "https://picsum.photos/seed/707/400/300", caption: "Desert Sand" },
// //   { url: "https://picsum.photos/seed/808/400/300", caption: "Autumn Leaves" },
// // ];

// function Pin({ color}) {
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         marginBottom: -10,
//         zIndex: 10,
//         position: "relative",
//       }}
//     >
//       <div
//         style={{
//           width: 16,
//           height: 16,
//           borderRadius: "50%",
//           background: `radial-gradient(circle at 35% 30%, ${color.shine}, ${color.head})`,
//           boxShadow: "0 2px 5px rgba(0,0,0,0.4), inset 0 -1px 2px rgba(0,0,0,0.2)",
//         }}
//       />
//       <div
//         style={{
//           width: 3,
//           height: 10,
//           background: "linear-gradient(to bottom, #bbb, #555)",
//           borderRadius: "0 0 2px 2px",
//           marginTop: -1,
//         }}
//       />
//     </div>
//   );
// }

// function PhotoCard({ photo, index }) {
//   const [hovered, setHovered] = useState(false);
//   const pin = PIN_COLORS[index % PIN_COLORS.length];
//   const rot = ROTATIONS[index % ROTATIONS.length];
//   const frame = FRAMES[index % FRAMES.length];
// console.log(photo)
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         padding: "0 4px 20px",
//       }}
//     >
//       <Pin color={pin} />
//       <div
//         onMouseEnter={() => setHovered(true)}
//         onMouseLeave={() => setHovered(false)}
//         style={{
//           width: "100%",
//           border: frame.border,
//           background: frame.bg,
//           paddingBottom: 28,
//           boxShadow: hovered
//             ? "6px 12px 30px rgba(0,0,0,0.28)"
//             : "3px 5px 14px rgba(0,0,0,0.18)",
//           transform: hovered
//             ? `rotate(${rot}deg) scale(1.05)`
//             : `rotate(${rot}deg) scale(1)`,
//           transition: "transform 0.25s ease, box-shadow 0.25s ease",
//           cursor: "pointer",
//         }}
//       >
//         <img
//           src={photo.url}
//           alt={photo.caption}
//           onError={(e) => {
//             e.target.src = `pgoto.url`;
//           }}
//           style={{
//             width: "100%",
//             aspectRatio: "4 / 3",
//             objectFit: "cover",
//             display: "block",
//           }}
//         />

//       </div>
//     </div>
//   );
// }

// export default function PinboardGallery({ PHOTOS = [] }) {
//   return (
//     <>
//       <style>{`
//         .pin-grid {
//           display: grid;
//           grid-template-columns: repeat(4, 1fr);
//           gap: 40px 20px;
//           padding: 16px 8px 32px;
//         }
//         @media (max-width: 1024px) {
//           .pin-grid { grid-template-columns: repeat(3, 1fr); }
//         }
//         @media (max-width: 700px) {
//           .pin-grid { grid-template-columns: repeat(2, 1fr); gap: 32px 14px; }
//         }
//         @media (max-width: 420px) {
//           .pin-grid { grid-template-columns: 1fr; gap: 28px 0; }
//         }
//       `}</style>

//      <div className="customcontainer">
//        <div style={{padding:'2rem 0'}}>
//         <div className="pin-grid">
//           {PHOTOS.map((photo, i) => (
//             <PhotoCard key={i} photo={photo} index={i} />
//           ))}
//         </div>
//       </div>
//      </div>
//     </>
//   );
// }

import { useState } from "react";

const PIN_COLORS = [
  { head: "#e53935", shine: "#ef9a9a" },
  { head: "#1e88e5", shine: "#90caf9" },
  { head: "#fdd835", shine: "#fff176" },
  { head: "#43a047", shine: "#a5d6a7" },
  { head: "#e91e63", shine: "#f48fb1" },
  { head: "#00acc1", shine: "#80deea" },
  { head: "#8e24aa", shine: "#ce93d8" },
  { head: "#f4511e", shine: "#ffab91" },
];

const ROTATIONS = [-3, 2, -1.5, 3.5, -2.5, 1.8, -3.8, 2.2, -2.2, 3.1];

const FRAMES = [
  { border: "9px solid #fff", bg: "#fff", capColor: "#666" },
];

function Pin({ color }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: -10,
        zIndex: 10,
        position: "relative",
      }}
    >
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: "50%",
          background: `radial-gradient(circle at 35% 30%, ${color.shine}, ${color.head})`,
          boxShadow:
            "0 2px 5px rgba(0,0,0,0.4), inset 0 -1px 2px rgba(0,0,0,0.2)",
        }}
      />
      <div
        style={{
          width: 3,
          height: 10,
          background: "linear-gradient(to bottom, #bbb, #555)",
          borderRadius: "0 0 2px 2px",
          marginTop: -1,
        }}
      />
    </div>
  );
}

function PhotoCard({ photo, index }) {
  const [hovered, setHovered] = useState(false);
  const pin = PIN_COLORS[index % PIN_COLORS.length];
  const rot = ROTATIONS[index % ROTATIONS.length];
  const frame = FRAMES[index % FRAMES.length];

  console.log(photo);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "0 4px 20px",
      }}
    >
      <Pin color={pin} />

      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: "100%",
          border: frame.border,
          background: frame.bg,
          paddingBottom: 28,
          boxShadow: hovered
            ? "6px 12px 30px rgba(0,0,0,0.28)"
            : "3px 5px 14px rgba(0,0,0,0.18)",
          transform: hovered
            ? `rotate(${rot}deg) scale(1.05)`
            : `rotate(${rot}deg) scale(1)`,
          transition: "transform 0.25s ease, box-shadow 0.25s ease",
          cursor: "pointer",
        }}
      >
        <img
          src={photo?.url}
          alt={photo?.caption || "image"}
          onError={(e) => {
            e.target.src = "https://picsum.photos/400/300";
          }}
          style={{
            width: "100%",
            aspectRatio: "4 / 3",
            objectFit: "cover",
            display: "block",
          }}
        />
      </div>
    </div>
  );
}

export default function PinboardGallery({ PHOTOS = [] }) {
  // ✅ Ensure order sorting (important for your backend data)
  const sortedPhotos = [...PHOTOS].sort((a, b) => a.order - b.order);

  return (
    <>
      <style>{`
        .pin-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 40px 20px;
          padding: 4rem 0 8rem 0;
        }
        @media (max-width: 1024px) {
          .pin-grid { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 700px) {
          .pin-grid { grid-template-columns: repeat(2, 1fr); gap: 32px 14px; }
        }
        @media (max-width: 420px) {
          .pin-grid { grid-template-columns: 1fr; gap: 28px 0; }
        }
      `}</style>

      <div className="customcontainer">
        <div >
          <div className="pin-grid">
            {sortedPhotos.map((photo, i) => (
              <PhotoCard key={photo.url} photo={photo} index={i} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}